<template>
  <div
    :id="`${EL_NAME.ROOT}_${id}`"
    class="multiselect-default"
    :class="openDirection"
  >
    <div class="tags" :class="{ show: isOpen }" @click="toggle(true)">
      <label v-show="!isOpen">
        <slot name="selection">
          {{ selected.length }} itens selecionado(s)
        </slot>
      </label>
      <input
        v-show="isOpen"
        v-model="search"
        @keyup="searchForOption"
        type="text"
        placeholder="Insira aqui sua chave de pesquisa"
      />
      <div class="icon-dropdown" @click.stop="toggle()">
        <img src="../assets/svg/arrow-select.svg" alt="Abrir multiselect" />
      </div>
    </div>

    <div class="content-wrapper" :class="{ show: isOpen }">
      <ul class="content">
        <template v-if="itemsDisplayed.length === 0">
          <li class="item no-results">
            <p>Sem resultados para "{{ search }}"</p>
          </li>
        </template>
        <template v-else>
          <li class="item" v-if="selectAllEnabled && !search">
            <label class="item-area" for="multiselect_checkbox_select_all">
              <input
                id="multiselect_checkbox_select_all"
                class="checkbox-default inverted"
                type="checkbox"
                v-model="selectAllOption"
                @change.prevent="toggleSelectAll(false)"
              />
              <label for="multiselect_checkbox_select_all">
                Selecionar todos
              </label>
            </label>
          </li>
          <template v-for="item in itemsDisplayed" :key="item">
            <li class="item">
              <label
                class="item-area"
                :for="`${EL_NAME.ROOT}_${id}_${EL_NAME.TYPE.INPUT_CHECKBOX}_${item[keyNameProperty]}`"
              >
                <input
                  v-model="selected"
                  :value="item[keyNameProperty]"
                  :id="`${EL_NAME.ROOT}_${id}_${EL_NAME.TYPE.INPUT_CHECKBOX}_${item[keyNameProperty]}`"
                  class="checkbox-default inverted"
                  type="checkbox"
                  @change="handler"
                />
                <label
                  :for="`${EL_NAME.ROOT}_${id}_${EL_NAME.TYPE.INPUT_CHECKBOX}_${item[keyNameProperty]}`"
                >
                  {{ item[labelNameProperty] }}
                </label>
              </label>
            </li>
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Array,
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    selectAllEnabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    noEmpty: {
      type: Boolean,
      required: false,
      default: true,
    },
    labelNameProperty: {
      type: String,
      required: false,
      default: "label",
    },
    keyNameProperty: {
      type: String,
      required: false,
      default: "key",
    },
  },

  emits: ["update:modelValue", "update"],

  data() {
    return {
      isOpen: false,
      maxHeight: 300,
      openDirection: "below",

      selected: [],
      selectAllOption: true,

      search: "",

      itemsDisplayed: [],

      EL_NAME: {
        ROOT: "multiselect",
        TYPE: {
          INPUT_TEXT: "input_text",
          INPUT_CHECKBOX: "input_checkbox",
        },
      },

      itemsKey: [],

      firstLoading: false,
    };
  },

  watch: {
    options: {
      handler() {
        if (!this.firstLoading) {
          // Chaves dos itens
          this.itemsKey = [...this.options].map(
            (item) => item[this.keyNameProperty]
          );
          // Verifica se deve iniciar com todas as opções selecionadas
          if (this.selectAllEnabled) this.toggleSelectAll(true);
          // Evento que detecta o clique fora do componente do multiselect
          document.addEventListener("click", this.listener, false);
          // Atualiza o v-model
          this.updateModelValue();
          // Itens que serão renderizados
          this.itemsDisplayed = [...this.options];

          this.firstLoading = true;
        }
      },
    },
  },

  created() {
    // // Chaves dos itens
    // this.itemsKey = [...this.options].map((item) => item[this.keyNameProperty]);
    // // Verifica se deve iniciar com todas as opções selecionadas
    // if (this.selectAllEnabled) this.toggleSelectAll(true);
    // // Evento que detecta o clique fora do componente do multiselect
    // document.addEventListener("click", this.listener, false);
    // // Atualiza o v-model
    // this.updateModelValue();
    // // Itens que serão renderizados
    // this.itemsDisplayed = [...this.options];
    // console.log(this.itemsDisplayed)
  },

  mounted() {
    // Verifica a posição inicial do multiselect na tela
    this.verifyPosition();
  },

  methods: {
    updateModelValue() {
      this.$emit("update:modelValue", this.selected);
      this.$emit("update");
    },

    handler(event) {
      const checkbox = event.target;

      if (this.selected.length < this.options.length)
        this.selectAllOption = false;

      if (this.selected.length === 0) {
        event.preventDefault();

        checkbox.checked = true;
        this.selected.push(checkbox.value);
      }

      if (this.selected.length === this.options.length) {
        this.selectAllOption = true;
      }

      this.updateModelValue();
    },

    listener(event) {
      if (this.isOpen) {
        const multiselectElement = document.getElementById(
          `${this.EL_NAME.ROOT}_${this.id}`
        );
        const currentElement = event.target;

        if (!multiselectElement.contains(currentElement)) {
          this.isOpen = false;
          this.searchIsEmpty();
        }
      }
    },

    searchIsEmpty() {
      this.search = "";
      this.itemsDisplayed = [...this.options];
    },

    toggle(forceOpen = false) {
      this.verifyPosition();
      if (forceOpen) this.isOpen = true;
      else this.isOpen = !this.isOpen;

      if (!this.isOpen) {
        this.searchIsEmpty();
      }
    },

    verifyPosition() {
      const spaceAbove = this.$el.getBoundingClientRect().top;
      const spaceBelow =
        window.innerHeight - this.$el.getBoundingClientRect().bottom;
      const hasEnoughSpaceBelow = spaceBelow > this.maxHeight;

      // Verifica se há espaço acima ou abaixo e define o sentido
      this.openDirection =
        hasEnoughSpaceBelow || spaceBelow > spaceAbove ? "below" : "above";
    },

    toggleSelectAll(forceSelectAll = false) {
      // Forçar selecionar todas as opções
      // if (forceSelectAll) {
      //   this.selected = [...this.itemsKey];
      //   return;
      // }

      if (this.selectAllOption || forceSelectAll) {
        this.selected = [...this.itemsKey];
        if (forceSelectAll) return;
      } else if (this.noEmpty) {
        this.selected = [this.itemsKey[0]];
      } else {
        this.selected = [];
      }

      this.updateModelValue();
    },

    searchForOption() {
      if (!this.isOpen) this.toggle();

      let search = this.search.toLowerCase();
      this.itemsDisplayed = [];

      if (!this.search) {
        this.searchIsEmpty();
        return;
      }

      for (let item of this.options) {
        let label = item.label.toLowerCase();

        if (label.includes(search)) {
          this.itemsDisplayed.push(item);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/variables.scss";

/* Personalização do scroll */

*::-webkit-scrollbar-track {
  border-radius: 10px;
}

/* Estilização do multiselect */

div.multiselect-default {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  transition: 0.25s linear;

  /* Estilização da barra de select */

  .tags {
    display: flex;
    justify-content: space-between;
    padding: 1em 1.5em;
    font-size: $text-md;
    color: $cinza-3;
    border-radius: 10px;
    border: 1px solid $preto-3;
    line-height: 1;
    cursor: pointer;

    /* Label do select */

    label {
      line-height: 21px;
    }

    /* Caixa de pesquisa do select */

    input {
      border: none;
      margin: 0;
      padding: 0;
      width: 100%;
    }

    input:focus-visible {
      outline: none;
    }

    .icon-dropdown {
      background-color: $branco-neutro;
      cursor: pointer;

      /* Ícone da seta */

      img {
        width: 1em;
        height: 1em;
        background-image: url("../assets/svg/arrow-select.svg");
        background-repeat: no-repeat;
        background-position: center;
      }
    }
  }

  .tags.show {
    border-radius: 10px 10px 0 0;
    border-bottom-color: $cinza-5;

    .icon-dropdown img {
      transform: rotate(180deg);
    }
  }

  /* Estilização do conteúdo exibido */

  div.content-wrapper {
    display: none;
    position: absolute;
    border: 1px solid $preto-3;
    background-color: $branco-neutro;
    border-radius: 0 0 10px 10px;
    width: 100%;
    max-height: 300px;
    overflow: auto;
    z-index: 50;

    .content {
      list-style: none;
      margin: 0;
      padding: 0;

      .item {
        font-size: $btn-md;
        font-weight: $bold;

        .item-area {
          display: flex;
          padding: 0.75em 1.5em;
          text-decoration: none;
          vertical-align: middle;
        }

        p {
          margin: auto;
        }

        input[type="checkbox"] {
          margin-right: 1em;
        }

        label {
          line-height: 25px;
          cursor: pointer;
        }
      }

      .item:not(:has(.item-area)) {
        display: flex;
        padding: 0.75em 1.5em;
        text-decoration: none;
        vertical-align: middle;
      }

      .item:not(.no-results):hover {
        background-color: $cinza-5;
        cursor: pointer;
      }
    }
  }

  div.content-wrapper.show {
    display: block;
    border-top: none;
  }
}

/* Estilização para o caso em que as opções aparecem acima */

div.multiselect-default.above {
  /* Estilização da barra de select */

  .tags {
    padding: 1em 1.5em;
    font-size: $text-md;
    color: $cinza-3;
    border-radius: 10px;
    border: 1px solid $preto-3;
    line-height: 1;
    cursor: pointer;

    .icon-dropdown img {
      transform: rotate(180deg);
    }
  }

  /* Barra de select quando as opções são exibidas */

  .tags.show {
    border-radius: 0 0 10px 10px;
    border-top-color: $cinza-5;

    .icon-dropdown img {
      transform: rotate(0);
    }
  }

  /* Estilização do conteúdo exibido */

  div.content-wrapper {
    border-radius: 10px 10px 0 0;
    border-top: 1px solid $preto-3;
  }

  div.content-wrapper.show {
    bottom: 100%;
    display: block;
    border-bottom: none;
  }
}
</style>
